import Checkbox from '@/components/forms/Checkbox';
import { COLORS } from '@/styles/color';
import { hexToRGBA } from '@/styles/color/utils';
import { paddingX } from '@/styles/layout/utils';
import { remCalc } from '@/styles/typography/utils';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface DropDownOptionProps extends PropsWithClassName {
  children?: ReactNode;
  title: string;
  checked: boolean;
  onToggle: (selected: boolean) => void;
}

const DropDownOption: FC<DropDownOptionProps> = (props) => (
  <li>
    <FilterOption onClick={() => props.onToggle(!props.checked)}>
      <StyledCheckbox checked={props.checked} onToggle={props.onToggle} />
      <span>{props.title}</span>
    </FilterOption>
  </li>
);

// #region - Components

const FilterOption = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${paddingX(8)};
  width: 100%;

  &:hover {
    background-color: ${hexToRGBA(COLORS.BLACK, 0.1)};
    border-radius: ${remCalc(10)};
  }

  &:hover,
  &:active,
  &:focus {
    outline: none;
  }

  input:checked {
    background-color: ${COLORS.BLACK};
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
      stroke: ${COLORS.WHITE};
    }
  }
`;

const StyledCheckbox = styled(Checkbox)`
  border: 1px solid ${COLORS.BLACK};
  border-radius: 100%;
  margin-right: ${remCalc(13)};

  input {
    border: none;
  }
`;

// #endregion - Components

export default DropDownOption;
